const allHashTags = {
  hashTags: [
    "artificial-intelligence",
    "java",
    "springboot",
    "react",
    "angular",
    "webservices",
    "spring",
    "javascript",
    "tools"
  ],
  hashTagColors: [
    "red",
    "blue",
    "warning",
    "info",
    "danger",
    "success",
    "green",
    "brown",
    "purple"
  ]
};

export default allHashTags;
